import { useCallback } from 'react'

import { useLocalStorage } from 'usehooks-ts'

import {
  MAX_RECENT_SEARCHES,
  RECENT_SEARCHES_KEY,
} from '../RecentSearch.constants.js'

export const useRecentSearch = () => {
  const [recentSearches, setRecentSearches] = useLocalStorage<string[]>(
    RECENT_SEARCHES_KEY,
    [],
  )

  const submit = useCallback(
    (query: string) => {
      // Skip empty or whitespace-only queries
      if (!query?.trim()) {
        return
      }

      const cleanQuery = query.trim()

      // Create new array with the following order:
      // 1. Add the new search term at the beginning
      // 2. Spread the existing searches, filtering out any case-insensitive duplicates
      // 3. Limit the array to MAX_RECENT_SEARCHES items
      const updatedSearches = [
        cleanQuery,
        ...(recentSearches ?? []).filter(
          item => item.toLowerCase() !== cleanQuery.toLowerCase(),
        ),
      ].slice(0, MAX_RECENT_SEARCHES)

      setRecentSearches(updatedSearches)
    },
    [recentSearches, setRecentSearches],
  )

  const remove = useCallback(
    (queryToRemove: string) => {
      const updatedSearches = (recentSearches ?? []).filter(
        item => item !== queryToRemove,
      )
      setRecentSearches(updatedSearches)
    },
    [recentSearches, setRecentSearches],
  )

  return {
    submit,
    remove,
    list: recentSearches ?? [],
  }
}
